var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('phone-field',{attrs:{"id":"phone-field","validation":_vm.$v,"validationMessage":_vm.textRequired,"label":_vm.textLabel,"rest":{
    placeholder: _vm.placeholder
      ? _vm.textLabel
      : null,
    autocomplete: 'off',
    name: 'phone',
  },"countryCode":_vm.ccform[_vm.ccname],"theme":"variant-1","tabindex":_vm.tabindex,"order":_vm.order},on:{"onCountryChange":_vm.setCountryCodeByPhoneField,"input":_vm.input,"blur":_vm.blur},model:{value:(_vm.form[_vm.name]),callback:function ($$v) {_vm.$set(_vm.form, _vm.name, $$v)},expression:"form[name]"}})}
var staticRenderFns = []

export { render, staticRenderFns }